/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaPayment } from "../../entities/yookassa/Payment";
import { yookassaAmountSchema } from "./amountSchema";
import { yookassaCancellationDetailsSchema } from "./cancellationDetailsSchema";
import { yookassaConfirmationSchema } from "./confirmationSchema";
import { yookassaPaymentMethodSchema } from "./paymentMethodSchema";
import { z } from "zod/v4";

export const yookassaPaymentSchema = z.object({
    get "amount"(){
                return yookassaAmountSchema.optional()
              },
get "cancellation_details"(){
                return yookassaCancellationDetailsSchema.optional()
              },
get "confirmation"(){
                return yookassaConfirmationSchema.optional()
              },
"id": z.optional(z.string()),
"paid": z.optional(z.boolean()),
get "payment_method"(){
                return yookassaPaymentMethodSchema.optional()
              },
"status": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaPayment>